import React, { FunctionComponent } from "react";
import { Badge, Skeleton, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";


interface IProps {
  state?: number;
}

export const RTU_STATUS = {
  NONE: 0,
  OK: 1,
  WARNING: 2,
  OFF: 3,
  ERROR: 4,
}


const RtuStatus: FunctionComponent<IProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case RTU_STATUS.NONE:
      return (
        <Badge variant={"outline"} colorScheme={"gray"} title={intl.formatMessage({
            id: "command__rtu__status__none",
            defaultMessage: "No state",
          })}>
          <Box display="inline-block" w="2" h="3" />
        </Badge>
      )
    case RTU_STATUS.OK:
      return (
        <Badge variant="solid" colorScheme={"green"}>
          {intl.formatMessage({
            id: "command__rtu__status__ok",
            defaultMessage: "OK",
          })}
        </Badge>
      )
    case RTU_STATUS.WARNING:
      return (
        <Badge variant="solid" colorScheme={"orange"}>
          {intl.formatMessage({
            id: "command__rtu__status__warning",
            defaultMessage: "WARNING",
          })}
        </Badge>
      )
    case RTU_STATUS.OFF:
      return (
        <Badge variant="solid" colorScheme={"blue"}>
          {intl.formatMessage({
            id: "command__rtu__status__off",
            defaultMessage: "OFF",
          })}
        </Badge>
      )
    case RTU_STATUS.ERROR:
      return (
        <Badge variant="solid" colorScheme={"red"}>
          {intl.formatMessage({
            id: "command__rtu__status__error",
            defaultMessage: "ERROR",
          })}
        </Badge>
      )
    default:
      return (
        <Skeleton minW={5} w={10} h={3} />
      )
  }
};

export default RtuStatus;
